const { h, render, Component } = require('preact');
const ClaimLevelSSA = require('./claim_level_ssa')

const CLAIM_LEVEL_SSAs = ['view_cashback', 'add_edit_card']

class SSAButtons extends Component {
  constructor(props) {
    super(props);
  }

  getClaimLevelSSAs(){
    return CLAIM_LEVEL_SSAs;
  }

  render() {
    let  claimLevelSSAList = this.getClaimLevelSSAs();
    return(
      <div>
        {(claimLevelSSAList.length > 0) &&
          <ClaimLevelSSA
            claimDetails = {this.props.claimDetails}
            SSAs = {claimLevelSSAList}
          />
        }
      </div>

    );
  }
}
module.exports = SSAButtons
